import { useBhanzuBuddyChat } from './use-bhanzu-buddy-chat';
import type { UseBhanzuBuddyChatProps } from './use-bhanzu-buddy-chat';

export const useOptionalBhanzuBuddyChat = (props?: UseBhanzuBuddyChatProps) => {
  const dummyProps: UseBhanzuBuddyChatProps = {
    leadId: 'dummy',
    source: 'explain_me',
  };

  const result = useBhanzuBuddyChat(props ?? dummyProps);

  if (!props?.leadId) {
    return {
      messages: [],
      isLoading: false,
      isHistoryLoading: false,
      onSendMessage: () => {},
      onSendQuickChallengeAnswer: () => {},
      appendBuddyMessage: () => {},
      onFeedback: () => {},
      onGuideMe: () => {},
      refetchWithSource: () => {},
      handleGuideFlow: () => {},
    };
  }

  return result;
};
